import Confetti from "react-confetti";

function ConfettiComponent() {
  return <Confetti numberOfPieces={50} />;
}

export default ConfettiComponent;
